// extracted by mini-css-extract-plugin
module.exports = {"faq":"SectionFaq_faq__k_fYq","container":"SectionFaq_container__6w9rB","faq__title":"SectionFaq_faq__title__iJ2YU","faq__list-container":"SectionFaq_faq__list-container__b9zVD"};